import React from 'react';

const DashboardScreen = () => {
  return (
    <section className="dashboard">
      <h1>Dashboard</h1>
    </section>
  );
};

export default DashboardScreen;
